export type { ProductDetailsSectionProps } from './ProductDetailsSection';
export { ProductDetailsSection } from './ProductDetailsSection';
